import React from 'react'
import { node, bool, string } from 'prop-types'
import { css } from '@emotion/react'

import mediaQueries from '@/layout/media-queries'

const wrapperCss = (withHover) => (theme) =>
  css`
    display: flex;
    text-decoration: none;
    color: ${theme.colors.black};
    border: 1px solid ${theme.colors.gray200};
    border-radius: 6px;
    position: relative;
    height: 138px;
    width: calc(100% - 32px);
    margin: 8px 16px;

    ${withHover &&
    css`
      cursor: pointer;
      :hover {
        background-color: ${theme.colors.aquaHaze};
      }
    `}

    ${mediaQueries.smallScreen()} {
      width: calc(50% - 32px);
      margin: 0 16px 32px 16px;
    }

    ${mediaQueries.largeScreen()} {
      width: calc(33.3% - 32px);
      margin: 0 16px 32px 16px;
    }

    ${mediaQueries.xlargeScreen()} {
      width: calc(33.3% - 40px);
      margin: 0 20px 40px 20px;
    }
  `

export const ProductCardBase = ({ children, withHover, className }) => (
  <article
    className={`item-card-base ${className || ''}`}
    css={wrapperCss(withHover)}
  >
    {children}
  </article>
)

ProductCardBase.propTypes = {
  children: node,
  withHover: bool,
  className: string,
}

export default ProductCardBase
